module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paging"
  }, [_c('span', [_vm._v(_vm._s(_vm.PagenumId) + "/" + _vm._s(_vm.PageCount))]), _vm._v(" "), _c('div', {
    staticClass: "lastone",
    on: {
      "click": _vm.lastone
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/pageL.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nextone",
    on: {
      "click": _vm.nextone
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/pageR.png"),
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-409032c8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paging/paging.vue
// module id = 1189
// module chunks = 1